module.exports = __webpack_public_path__ + "static/media/check-circle.2695b75f.svg";